import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import EnquiryDialog from "@/components/EnquiryDialog";
import { ShieldCheck, Award } from "lucide-react";

export default function Refurbished() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  useEffect(() => { api.get("/refurbished").then(r => setItems(r.data)); }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 py-16">
      <div className="max-w-2xl">
        <Badge className="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-amber-700 hover:bg-amber-50">
          <Award className="mr-1.5 h-3.5 w-3.5" /> Certified Pre-Owned
        </Badge>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-[#0F2942] sm:text-5xl" style={{ fontFamily: "Outfit, sans-serif" }}>{t("refurb.title")}</h1>
        <p className="mt-3 text-lg text-slate-600">{t("refurb.subtitle")}</p>
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((p) => (
          <div key={p.id} data-testid={`refurb-card-${p.id}`} className="group overflow-hidden rounded-xl border border-slate-200 bg-white transition-all hover:shadow-xl">
            <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
              {p.images?.[0] && <img src={p.images[0]} alt={p.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />}
              <span className="absolute left-3 top-3 rounded-full bg-amber-600 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-white">{t("refurb.badge")}</span>
            </div>
            <div className="p-5">
              <div className="text-xs font-semibold uppercase tracking-wider text-teal-700">{p.category}</div>
              <h3 className="mt-2 line-clamp-2 text-base font-semibold text-[#0F2942]">{p.name}</h3>
              <div className="mt-3 flex flex-wrap gap-2">
                <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-emerald-700">
                  <ShieldCheck className="mr-1 inline h-3 w-3" /> {t("refurb.condition")}: {p.condition}
                </span>
                <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-slate-700">
                  {p.warranty_months} {t("refurb.months")} {t("refurb.warranty")}
                </span>
              </div>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-sm font-bold text-[#0F2942]">
                  {p.price_on_request ? t("product.por") : `₹ ${p.price?.toLocaleString("en-IN")}`}
                </span>
                <Button size="sm" onClick={() => setSelected(p)} data-testid={`refurb-enquire-${p.id}`} className="bg-[#0F2942] text-white hover:bg-[#0A192F]">
                  {t("product.enquire")}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <EnquiryDialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)} product={selected} />
    </div>
  );
}
